import React, { useEffect, useState } from "react";

import {
  Alert,
  Box,
  CssBaseline,
  Snackbar,
  Typography,
  createSvgIcon,
} from "@mui/material";

import { ReactComponent as IconFlow } from "../../assets/icons/IconEasyFlow.svg";
import { ReactComponent as IconReport } from "../../assets/icons/IconEasyReport.svg";
import { ReactComponent as IconMaps } from "../../assets/icons/IconEasyMaps.svg";
import { ReactComponent as IconLogo } from "../../assets/logosSvg/logoMW.svg";
import { ReactComponent as IconLog } from "../../assets/icons/IconEasyLog.svg";
import { Outlet, useLocation } from "react-router-dom";
import {
  Home,
  PlaylistAdd,
  RouterOutlined,
  SupervisorAccountOutlined,
  SupportAgent,
} from "@mui/icons-material";
//import LoadingPage from "../../componentes/loadingPage";
import TopBar from "../../componentes/topBar";
import SideBar from "../../componentes/sideBar";
import ModulesAlert from "../../componentes/modulesAlert";
import { ErrorBoundary } from "react-error-boundary";
import ErrorMessage from "../../componentes/easyMaps/errorMessage";

const EasyFlowIcon = createSvgIcon(<IconFlow />);
const EasyReportIcon = createSvgIcon(<IconReport />);
const EasyMapsIcon = createSvgIcon(<IconMaps />);
const EasyLogIcon = createSvgIcon(<IconLog />);

function Layout(params) {
  const { colorMode, setColorMode, socket, socketCliente } = params;

  const [snackbar, setSnackbar] = useState(null);
  const [openRightBar, setOpenRightBar] = useState(true);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [titlePage, setTitlePage] = useState("");
  const [link, setLink] = useState("");
  const [pageConfig, setPageConfig] = useState(false); // armazena se a pina atual é a configuração
  const location = useLocation();

  const clientLogo =
    colorMode === true
      ? `${
          window?.config?.REACT_APP_LOGO_MODE_DARK_URL ||
          window?.config?.REACT_APP_LOGO_URL ||
          ""
        }`
      : `${window?.config?.REACT_APP_LOGO_URL || ""}`;
  const isPartner = window?.config?.REACT_APP_IS_PARTNER === "true" || false;

  const styles = {
    containerLayout: {
      display: "flex",
      width: "100%",
      height: "fit-content",
      flexDirection: "column",
    },
    containerBody: {
      display: "flex",
      width: "100%",
      height: "100%",
      minWidth: "350px",
    },
    containerOutlet: {
      flexGrow: 1,
      padding: 3,
      // paddingTop: 5,
      width: "100%",
      gap: 2,
      minWidth: "calc(100vw - 300px)",
    },
    titleAndLinkPage: {
      flexGrow: 1,
      fontWeight: 400,
      fontSize: "1.25rem",
      marginX: 1,
      mt: 1,
      mb: 2,
    },
  };
  const rightBarPages = [
    {
      itemId: "1",
      label: "Home",
      link: "/homeIn",
      hideTitle: true,
      icon: <Home />,
      group: "Navegação",
    },
    {
      itemId: "2",
      label: "Adição de Host",
      link: "/easyAdd",
      icon: <PlaylistAdd />,
      group: "Navegação",
    },
    ...(!isPartner
      ? [
          {
            itemId: "3",
            label: "Suporte",
            link: "/suporte",
            icon: <SupportAgent />,
            group: "Navegação",
          },
          {
            itemId: "4",
            label: "EasyFlow",
            link: "/easyFlow",
            icon: <EasyFlowIcon />,
            group: "Navegação",
            openItem: true,
            nodes: [
              {
                itemId: "4.1",
                label: "Relatórios Flow",
                link: "/easyFlow/relatoriosFlow",
              },
            ],
          },
        ]
      : []),

    {
      itemId: "5",
      label: "EasyReport",
      link: "/easyReport",
      hideTitle: true,
      icon: <EasyReportIcon />,
      group: "Navegação",
    },
    {
      itemId: "6",
      label: isPartner ? "Mapas" : "EasyMaps",
      link: "/easyMaps",
      icon: <EasyMapsIcon />,
      openInNewTab: true,
      group: "Navegação",
    },
    {
      itemId: "7",
      label: isPartner ? "Log" : "EasyLog",
      hideTitle: true,
      link: "/easyLog",
      icon: <EasyLogIcon />,
      openItem: true,
      group: "Navegação",
      nodes: [
        {
          itemId: "7.1",
          label: "Histórico de Logs",
          link: "/easyLog/histor ico",
          hideTitle: true,
        },
        {
          itemId: "7.2",
          label: "Insights",
          link: "/easyLog/insights",
          hideTitle: true,
        },
      ],
    },
  ];
  const rightBarPagesConfig = [
    {
      itemId: "1",
      label: "Gestão de usuários",
      link: "/configuracoes/administracao",
      icon: <SupervisorAccountOutlined />,
      hideTitle: true,
      group: "Sistema",
    },
    {
      itemId: "2",
      label: "EasyLogs",
      link: "/configuracoes/easyLogs",
      icon: <EasyLogIcon />,
      hideTitle: true,
      group: "Produtos",
    },
    {
      itemId: "3",
      label: "EasyReport",
      link: "/configuracoes/easyReport",
      icon: <EasyReportIcon />,
      hideTitle: true,
      group: "Produtos",
    },
  ];

  useEffect(() => {
    setPageConfig(location.pathname.includes("/configuracoes"));
  }, [location.pathname]);

  return (
    <Box display={"flex"} sx={{ flexDirection: "column", height: "100%" }}>
      <ModulesAlert />
      <CssBaseline />

      <Box sx={styles.containerLayout}>
        <TopBar
          setOpenDrawer={setOpenDrawer}
          setOpenRightBar={setOpenRightBar}
          iconLogo={<IconLogo />}
          clientLogo={clientLogo}
          link={"/homeIn"}
          socket={socket}
          socketCliente={socketCliente}
          colorMode={colorMode}
          setColorMode={setColorMode}
          snackbar={snackbar}
          setSnackbar={setSnackbar}
          openRightBar={openRightBar}
        />{" "}
        <Box sx={styles.containerBody}>
          <SideBar
            items={pageConfig ? rightBarPagesConfig : rightBarPages}
            title="Navegação"
            openRightBar={openRightBar}
            setOpenRightBar={setOpenRightBar}
            openDrawer={openDrawer}
            setOpenDrawer={setOpenDrawer}
            iconLogo={<IconLogo />}
            clientLogo={clientLogo}
            titlePage={titlePage}
            setTitlePage={setTitlePage}
            link={link}
            setLink={setLink}
          />
          <Box sx={{ display: "flex", flexDirection: "column", width: "100%" }}>
            <Box component="main" sx={styles.containerOutlet}>
              {/* <Link
              href={link}
              color="text.secondary"
              sx={styles.titleAndLinkPage}
            >
              {titlePage}
            </Link> */}
              <ErrorBoundary
                FallbackComponent={() => (
                  <ErrorMessage
                    message={"Algo deu errado ao carregar o sistema"}
                  />
                )}
              >
                {titlePage && (
                  <Typography
                    color="text.primary"
                    variant="h5"
                    sx={styles.titleAndLinkPage}
                  >
                    {titlePage}
                  </Typography>
                )}
                <Outlet context={{ setTitlePage, socketCliente }} />
              </ErrorBoundary>
            </Box>
          </Box>
        </Box>
      </Box>
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}
    </Box>
  );
}

export default Layout;
